function initExperiencesCards() {
  const cards = document.querySelectorAll('.l-experiences__cards-card');
  if (!cards.length) return;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  cards.forEach((card) => {
    const btn = card.querySelector('.js-open-button');

    if (!isMobile) {
      card.addEventListener('mouseenter', () => {
        cards.forEach((c) => {
          if (c !== card) c.classList.remove('is-open');
        });
        card.classList.add('is-open');
      });

      card.addEventListener('mouseleave', () => {
        card.classList.remove('is-open');
      });
    }

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = card.classList.contains('is-open');

        cards.forEach((c) => c.classList.remove('is-open'));

        if (!isOpen) {
          card.classList.add('is-open');
        }
      });
    }

    if (isMobile) {
      document.addEventListener('click', (e) => {
        if (!card.contains(e.target)) {
          card.classList.remove('is-open');
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initExperiencesCards();
});

if (window.acf?.addAction) {
  const rerender = ($el) => {
    initExperiencesCards($el[0] || $el);
  };
  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
